module.exports = __webpack_public_path__ + "static/media/83.5c2f89ec.jpg";